// extracted by mini-css-extract-plugin
module.exports = {"trendIcon":"jgp-3BQBm","banner":"jgp-2SFY6"};